<template>
  <w-icon-wrapper icon-name='work-dashboard-icon'>
    <path
      id='Pfad_55633'
      d='M10,2.05a10.1,10.1,0,0,0-2,.37A11,11,0,1,0,21.58,16a10.1,10.1,0,0,0,.37-2H10ZM19.48,16A9,9,0,1,1,8,4.52V16Z'
      data-name='Pfad 55633'
      fill='currentColor'
    />
    <path
      id='Pfad_55634'
      d='M12,0V12H24A12,12,0,0,0,12,0Zm2,2.2A10.031,10.031,0,0,1,21.8,10H14Z'
      data-name='Pfad 55634'
      fill='currentColor'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconDashboard' };
</script>
